@if (!loading)  {
<!--  <div class="dialog-top position-relative">-->
    <img class="w-100" src="{{data.image}}" alt="{{data.image_alt}}"/>
<!--  </div>-->


  <div class="dialog-popup" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type">
    <h2 class="title px-l">{{data.title}}</h2>

    @for (part of parsedBody; track $index) {
      <div class="px-l">
        @if (part.type === 'string') {
          <div [innerHTML]="part.data"></div>
        }

        @if (part.type === 'form') {
        }

        @if (part.type === 'email') {
          <div class="d-flex">
            <div class="email-field notification info">
              <span>{{ part.email }}</span>
              <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="px-l pb-l popup-actions">
    <div class="popup-actions__row">
      <button mat-flat-button color="primary" [disabled]="saving()" (click)="onRedirect()">Benachrichtigungen verwalten</button>
      <button mat-button [disabled]="saving()" (click)="onSubscribe()">Später Erinnern</button>
    </div>
    <button
      mat-stroked-button
      class="popup-actions__full-width"
      (click)="onUseSuggestedAddress()"
      [disabled]="!suggestedEmail || saving()">
      Benachrichtigung mit vorgeschlagener Adresse nutzen
    </button>
  </div>
  @if (error()) {
    <p class="text-danger px-l" role="alert">{{ error() }}</p>
  }
}
